/* eslint-disable react/require-default-props */
import { IPageContent } from "api/interfaces/static-content.type";
import { checkIfResponsiveMediaIsPresent } from "component/landing-page/ArticleLandingPage.utils";
import { checkIfBannerV2IsPresent } from "component/landing-page/checkIfBannerV2IsPresent";
import useScreenSize from "hoc/useScreenSize";
import { useRouter } from "next/router";
import HideIf from "util/HideIf";
import { DEFAULT_CATEGORY_BANNER } from "../../../modules/site-structure/common/make-model-year-utils";
import { deepFind } from "../../../util/helper/deepFind";
import { getRelativeImagePath } from "../../../util/helper/getRelativeImagePath";
import BannerImagesV2 from "./BannerImagesV2";
import BannerWithFallback from "./BannerWithFallback";
import { IResponsiveMediaData, ResponsiveBanner } from "./Responsivebanner";
import styles from "./categoryBannerRegular.module.scss";

interface IProps {
  bannerData?: any;
  staticContent?: IPageContent;
  breadcrumb: any | null;
  responsiveBannerMedia?: IResponsiveMediaData | null;
  showBreadCrumb?: boolean;
  className?: string;
  maintainAspectRatio: boolean;
  bannerProps?: any;
  applyStyle?: boolean;
  desktopWidth?: number;
  height?: number;
  fullWidthBanner?: boolean;
}

function CategoryBannerRegular({
  bannerData, staticContent, breadcrumb,
  responsiveBannerMedia = null,
  showBreadCrumb = true,
  className = "",
  bannerProps = {},
  maintainAspectRatio,
  applyStyle = true,
  desktopWidth,
  desktopHeight,
  fullWidthBanner,
}: IProps) {
  const pageDisplayableTitle = deepFind(staticContent, "pageDetails.pageDisplayableTitle", bannerData?.categoryDisplayableTitle);
  const router = useRouter();

  const { bannerImagesV2, bannerAltText, bannerTitleText } = staticContent || {};

  const isResponsiveBannerMediaPresent = checkIfResponsiveMediaIsPresent(responsiveBannerMedia);
  const isBannerV2ImagesPresent = checkIfBannerV2IsPresent(bannerImagesV2);
  if (router.pathname === "/search") {
    return <span />;
  }

  const [isMobile] = useScreenSize();

  const bannerImageUrl = deepFind(staticContent, isMobile ? "bannerImages.mobileImage" : "bannerImages.desktopImage", bannerData?.bannerImageUrl || bannerData?.fallbackImage) || DEFAULT_CATEGORY_BANNER;
  const bannerDimensions = isMobile ? { width: 1000, height: 250 } : { width: 400, height: 100 };
  const style = isMobile && applyStyle ? { maxHeight: 100 } : {};

  return (
    <>
      <div className={`${styles.category_banner} ${className}`}>
        <HideIf
          show={!isResponsiveBannerMediaPresent && !isBannerV2ImagesPresent}
        >
          <BannerWithFallback
            src={getRelativeImagePath(bannerImageUrl)}
            fallbackImage={bannerData?.fallbackImage}
            alt={pageDisplayableTitle}
            {...{ bannerDimensions }}
            style={style}
            {...bannerProps}
            maintainAspectRatio={maintainAspectRatio}
            applyStyle={applyStyle}
            bannerAltText={bannerAltText}
            bannerTitleText={bannerTitleText}
            fullWidthBanner={fullWidthBanner}
          />
        </HideIf>

        <HideIf show={isBannerV2ImagesPresent}>
          <BannerImagesV2 bannerImages={bannerImagesV2} desktopWidth={desktopWidth} desktopHeight={desktopHeight} />
        </HideIf>

        <HideIf show={isResponsiveBannerMediaPresent && !isBannerV2ImagesPresent}>
          <ResponsiveBanner
            responsiveMedia={responsiveBannerMedia}
            maintainAspectRatio={maintainAspectRatio}
          />
        </HideIf>
        <HideIf show={showBreadCrumb && breadcrumb}>
          <div
            className={styles.category_breadrcrumb}
            style={isResponsiveBannerMediaPresent ? {
              position: "relative",
              top: "calc(-1 * var(--safari-root-font, 10px))",
            } : undefined}
          >
            {breadcrumb}
          </div>
        </HideIf>

      </div>

      {/* <hr style={{ borderColor: "#d7d7d7" }} /> */}
    </>
  );
}

export default CategoryBannerRegular;
